(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["londa-newsletter"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    const link = event.target.closest('a[href]');
    if (!link) return;
    const destination = new URL(link.href, window.location.href);
    const target = document.getElementById('londa-newsletter');
    if (!target || destination.hash !== '#londa-newsletter' || destination.origin !== window.location.origin || destination.pathname !== window.location.pathname) return;
    const menu = link.closest('[data-js-popup-name="navigation"]');
    if (!menu) return;
    if (!window.theme || !window.theme.Popups || !window.theme.Popups.closeByName) return;
    event.preventDefault();
    event.stopPropagation();
    window.theme.Popups.closeByName('navigation', null, function () {
      window.requestAnimationFrame(function () {
        target.scrollIntoView({ behavior: 'auto', block: 'start' });
        const heading = target.querySelector('h2');
        if (heading) heading.focus({ preventScroll: true });
      });
    });
  }, true);

  } catch(e) { console.error(e); }
})();
})();
